import "jquery-drawer"

const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB

export function initMaterialSearch(): void {
  $("#material-search-input").off("keydown").on("keydown", function(e) {
    if (e.key !== "Enter") return;
    const query = ($(this).val() as string).trim();
    const url = new URL(window.location.href);
    if (query) {
      url.searchParams.set("query", query);
    } else {
      url.searchParams.delete("query");
    }
    window.location.href = url.toString();
  });

  $("#material-search-input").off("input.clear").on("input.clear", function() {
    const hasValue = ($(this).val() as string).length > 0;
    $("#material-search-clear").toggleClass("d-none", !hasValue);
  });

  $("#material-search-clear").off("click").on("click", function() {
    const url = new URL(window.location.href);
    if (url.searchParams.has("query")) {
      url.searchParams.delete("query");
      window.location.href = url.toString();
    } else {
      $("#material-search-input").val("");
      $(this).toggleClass("d-none", true);
    }
  });

  initMaterialTabs();
}

function initMaterialTabs(): void {
  const navigate = (mutate: (params: URLSearchParams) => void): void => {
    const url = new URL(window.location.href);
    mutate(url.searchParams);
    url.searchParams.delete("page");
    window.location.href = url.toString();
  };

  $("#library-tabs .arf-tab").off("click.libtab").on("click.libtab", function() {
    const format = String($(this).data("format"));
    navigate((params) => format === "all" ? params.delete("material_format") : params.set("material_format", format));
  });

  $("#library-sort button").off("click.libsort").on("click.libsort", function() {
    const sort = String($(this).data("sort"));
    navigate((params) => sort === "newest" ? params.delete("sort") : params.set("sort", sort));
  });
}

export function initViewMaterial(): void {
  $(document).off("click.viewMat").on("click.viewMat", ".lib-card", function() {
    const $card = $(this);
    const name = String($card.data("name") ?? "");
    const src = String($card.data("src") ?? "");
    const type = String($card.data("material-type") ?? "");
    const width = $card.data("width");
    const height = $card.data("height");

    $("#view-material-name").text(name);
    $("#view-material-type").text(type ? type.toUpperCase() : "");
    $("#view-material-dims").text(width && height ? `${width} × ${height}` : "");

    const $img = $("#view-material-img");
    const $video = $("#view-material-video");
    const videoEl = $video[0] as HTMLVideoElement | undefined;

    if (type === "video") {
      $img.prop("hidden", true).attr("src", "");
      $video.attr("src", src).prop("hidden", false);
      videoEl?.load();
    } else {
      if (videoEl) { videoEl.pause(); videoEl.removeAttribute("src"); videoEl.load(); }
      $video.prop("hidden", true);
      $img.attr("src", src).attr("alt", name).prop("hidden", false);
    }

    $("#view-material-modal").modal("show");
  });

  $("#view-material-modal").off("hidden.bs.modal.viewMat").on("hidden.bs.modal.viewMat", function() {
    const videoEl = $("#view-material-video")[0] as HTMLVideoElement | undefined;
    if (videoEl) {
      videoEl.pause();
      videoEl.removeAttribute("src");
      videoEl.load();
    }
    $("#view-material-img").prop("hidden", true).attr("src", "");
    $("#view-material-video").prop("hidden", true);
  });
}

export function initAddMaterial(): void {
  const $dropzone = $("#asset-dropzone");
  const $dropInner = $("#asset-drop-inner");
  const $fileInput = $("#asset-file-input");
  const $preview = $("#asset-preview");
  const $previewImg = $("#asset-preview-img");
  const $previewVideo = $("#asset-preview-video");
  const $previewName = $(".asset-preview-name");
  const $previewSize = $("#asset-preview-size");
  let currentObjectUrl: string | null = null;

  $("#save-material-btn").off("click").on("click", function(e){
    e.preventDefault()
    const $name = $("#material-name")
    const $asset = $("#asset-file-input")
    const $format = $("#material-format")
    const $formatOption = $format.find("option:selected")
    const name  = $name.val() as string;
    const width = parseInt(String($formatOption.data("width") ?? 1080), 10);
    const height = parseInt(String($formatOption.data("height") ?? 1080), 10);
    const materialType = $dropzone.data("material-type");
    const file = ($asset[0] as HTMLInputElement).files?.[0];

    clearErrors();
    let isValid = true;
    if (!name) {
      showError($name, "Material name is required.");
      isValid = false;
    }
    if (!file) {
      showError($("#asset-dropzone"), "Please select an image or video file.");
      isValid = false;
    }
    if (!isValid) return;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("material_type", materialType);
    formData.append("width", String(width));
    formData.append("height", String(height));
    formData.append("asset", file!);

    const $modalContent = $("#add-material-modal .modal-content");

    $.ajax({
      url: "/meta_ads_materials",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: function() {
        $modalContent.css({ "pointer-events": "none", "opacity": 0.9 });
        if ($modalContent.find(".ajax-loading-spinner").length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `);
          $modalContent.append(spinner);
        }
      },
      success: function(response){
        location.reload()
      },
      error: function(xhr) {
        console.error(xhr.responseText);
        $modalContent.css({ "pointer-events": "", "opacity": "" });
        $modalContent.find(".ajax-loading-spinner").remove();
        $("#flash-container").html(xhr.responseJSON.flash)
      }
    })
  })

  $("#material-name").off('change').on('change', function() {
    $("#material-name").removeClass('is-invalid')
    $(".material_name > .invalid-feedback").remove()
  })

  
  $(".add-material-button").off("click").on("click", function() {
    const modal = $("#add-material-modal")
    $("#material-name").val("")
    $("#material-format").val("square")
    resetState();
    modal.modal("show")
  })

  // Browse button
  $("#asset-browse-btn").off("click").on("click", function() {
    resetState();
    $fileInput.trigger("click");
  });

  // File input change
  $("#asset-file-input").off("change").on("change", function() {
    const file = (this as HTMLInputElement).files?.[0];
    if (!file) return;
    if (!isValidFile(file)) {
      alert("Only images and videos are allowed.");
      (this as HTMLInputElement).value = "";
      return;
    }
    showPreview(file);
  });

  // Drag over / leave
  $("#asset-dropzone").off("dragenter dragover").on("dragenter dragover", function(e){
    e.preventDefault();
    $dropzone.addClass("asset-dropzone--over");
  })

  $("#asset-dropzone").off("dragleave drop").on("dragleave drop", function(e){
    e.preventDefault();
    $dropzone.removeClass("asset-dropzone--over");
  })

  $("#asset-dropzone").off("drop").on("drop", function(e){
    e.preventDefault();
    resetState();
    $dropzone.removeClass("asset-dropzone--over");
    const file = (e.originalEvent as DragEvent).dataTransfer?.files[0];
    if (!file) return;
    if (!isValidFile(file)) {
      alert("Only images and videos are allowed.");
      return;
    }
    const dt = new DataTransfer();
    dt.items.add(file);
    ($fileInput[0] as HTMLInputElement).files = dt.files;
    showPreview(file);
  })

  $("#asset-remove-btn").off("click").on("click", function() {
    resetState();
  });

  function showPreview(file: File): void {
    if (file.size > MAX_FILE_SIZE) {
      alert("File size exceeds 100MB. Please choose a smaller file.");
      return;
    }

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = ev => {
        const src = ev.target?.result as string;

        const img = new Image();
        img.onload = () => {
          $previewSize.text(`${img.naturalWidth} x ${img.naturalHeight}`);
          $dropzone.data("width", img.naturalWidth);
          $dropzone.data("height", img.naturalHeight);
        };
        img.src = src;

        $previewVideo.prop("hidden", true);
        $previewImg.attr("src", src).prop("hidden", false);
      };
      reader.readAsDataURL(file);
    } else {
      if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);

      currentObjectUrl = URL.createObjectURL(file);

      const video = document.createElement("video");
      video.onloadedmetadata = () => {
        $previewSize.text(`${video.videoWidth} x ${video.videoHeight}`);
        $dropzone.data("width", video.videoWidth);
        $dropzone.data("height", video.videoHeight);
      };
      video.src = currentObjectUrl;

      $previewImg.prop("hidden", true);
      $previewVideo.prop("hidden", false);

      $("#asset-preview-video-el").attr("src", currentObjectUrl).prop("hidden", false);
    }

    $previewName.text(file.name);
    $dropzone.addClass("has-asset");
    $dropzone.data("material-type", file.type.startsWith("image/") ? "image" : "video");
    $dropInner.hide();
    $preview.prop("hidden", false);
  }

  function isValidFile(file: File): boolean {
    return file.type.startsWith("image/") || file.type.startsWith("video/");
  }

  function removeAsset() {
    if (currentObjectUrl) {
      URL.revokeObjectURL(currentObjectUrl);
      currentObjectUrl = null;
    }
    ($fileInput[0] as HTMLInputElement).value = "";
    $preview.prop("hidden", true);
    $previewImg.prop("hidden", true).attr("src", "");
    $previewVideo.prop("hidden", true);
    $dropInner.show();
    $dropzone.removeClass("has-asset");
    $previewName.text('') 
  }

  function showError($el: JQuery, message: string): void {
    $el.addClass("is-invalid");
    $el.after(`<p class="invalid-feedback d-block text-danger small mt-1">${message}</p>`);
  }

  function clearErrors(): void {
    $(".is-invalid").removeClass("is-invalid");
    $(".invalid-feedback").remove();
  }

  function resetState() {
    clearErrors()
    removeAsset()
  }
}
